module.exports = __webpack_public_path__ + "3e43a5d764f841e7e78896de82cd6c50.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/media_control/public/Player-Regular.ttf
 ** module id = 46
 ** module chunks = 0
 **/